import { Star } from "lucide-react";
import { t } from "@/lib/i18n";

export const RatingBadge = ({ rating, testid = "rating-badge" }) =>
  rating ? (
    <span data-testid={testid} className="inline-flex items-center gap-1 text-xs font-bold text-amber-300">
      <Star size={13} className="fill-amber-300 text-amber-300" /> {Number(rating.avg).toFixed(1)}
      <span className="text-[#94A3B8] font-semibold">({rating.count})</span>
    </span>
  ) : null;

export const StarInput = ({ label, value, onChange, testid }) => (
  <div className="flex items-center justify-between gap-3">
    <span className="text-sm font-semibold text-white">{label}</span>
    <div className="flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" data-testid={`${testid}-${n}`} aria-label={`${n} stelle`} onClick={() => onChange(n)} className="p-1 transition-transform active:scale-90">
          <Star size={26} className={n <= value ? "fill-amber-300 text-amber-300" : "text-[#3f3f46]"} />
        </button>
      ))}
    </div>
  </div>
);

const LABELS = [["punctuality", "Puntualità"], ["cleanliness", "Pulizia mezzo"], ["professionalism", "Professionalità"]];

export const RatingSummary = ({ rating }) => (
  <div data-testid="rating-summary" className="ff-card p-4 flex flex-col gap-2">
    <div className="flex items-center justify-between">
      <span className="ff-label !mb-0">{t("Reputazione flotta")}</span>
      {rating ? <RatingBadge rating={rating} testid="rating-summary-badge" /> : <span className="text-xs text-[#94A3B8]">{t("Nessuna recensione")}</span>}
    </div>
    {rating && LABELS.map(([k, l]) => (
      <div key={k} className="flex items-center justify-between text-sm text-[#CBD5E1]"><span>{l}</span><span className="font-bold text-white">{Number(rating[k]).toFixed(1)} / 5</span></div>
    ))}
  </div>
);
